module.exports = __webpack_public_path__ + "img/AVEDA.9e3ab45f.svg";